import React from "react";
import {
    Container,
    Middle,
    MiddleLeft,
    MiddleRight,
    MainMenuWrapper,
} from "@Styled/Layout";
import { MainMenu } from "@Components";
import { ChannelContainer } from "@Components/ChannelContainer";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";

const WithDefaultLayout = (WrappedComponent: React.FC) => (props: any) => {
    return (
        <>
            <MainMenuWrapper>
                <MainMenu />
            </MainMenuWrapper>
            <Container>
                <Middle>
                    <MiddleLeft>
                        <Box
                            sx={{
                                display: "flex",
                                flex: 1,
                                height: "100%",
                                "& > *": {
                                    margin: (theme) => theme.spacing(0, 2),
                                    width: (theme) => theme.spacing(30),
                                    height: "100%",
                                    maxHeight: "100%",
                                    overflow: "auto",
                                },
                            }}
                        >
                            <Paper
                                elevation={0}
                                className="custom-scrollbar sidebar-scroll-container"
                            >
                                <ChannelContainer />
                            </Paper>
                        </Box>
                    </MiddleLeft>
                    <MiddleRight>
                        <WrappedComponent
                            id="wrapped-default-layout"
                            {...props}
                        />
                    </MiddleRight>
                </Middle>
            </Container>
        </>
    );
};

export default WithDefaultLayout;
